'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arguments = require('./arguments');

var _arguments2 = _interopRequireDefault(_arguments);

var _utils = require('./utils');

var _hooks = require('./hooks');

var _hooks2 = _interopRequireDefault(_hooks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  _: _utils._,
  getArguments: _arguments2.default,
  stripSlashes: _utils.stripSlashes,
  hooks: _hooks2.default,
  matcher: _utils.matcher,
  sorter: _utils.sorter,
  select: _utils.select,
  makeUrl: _utils.makeUrl,
  // lodash functions
  each: _utils.each,
  some: _utils.some,
  every: _utils.every,
  keys: _utils.keys,
  values: _utils.values,
  isMatch: _utils.isMatch,
  isEmpty: _utils.isEmpty,
  isObject: _utils.isObject,
  extend: _utils.extend,
  omit: _utils.omit,
  pick: _utils.pick,
  merge: _utils.merge
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/feathers-commons/lib/commons.js
// module id = 22
// module chunks = 3